import * as t from 'io-ts';
import { ProblemWithErrorCodeCodec } from '../../app/api/types/problemApi.types';

export const QueryFailedErrorResponseCodec = t.intersection([
    ProblemWithErrorCodeCodec,
    t.type({
        error_code: t.literal('query-failed'),
    }),
    t.partial({
        query_id: t.string,
    }),
]);
